"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFuturesTickerParseContext = exports.useFuturesCurTickerContext = exports.FuturesCurTickerContext = void 0;
const react_1 = require("react");
const trade_quotation_lib_1 = require("trade_quotation_lib");
exports.FuturesCurTickerContext = (0, react_1.createContext)({});
const useFuturesCurTickerContext = () => {
    return (0, react_1.useContext)(exports.FuturesCurTickerContext);
};
exports.useFuturesCurTickerContext = useFuturesCurTickerContext;
function useFuturesTickerParseContext(props) {
    var _a;
    const { base, quote, isFocused = true } = props;
    const curTicker = (_a = (0, exports.useFuturesCurTickerContext)()) === null || _a === void 0 ? void 0 : _a.ticker;
    const alreadyHad = !!curTicker && curTicker.base === base && curTicker.quote === quote;
    const ticker = (0, trade_quotation_lib_1.useTicker)({ base, quote, isActive: isFocused && !alreadyHad });
    return alreadyHad ? curTicker : ticker;
}
exports.useFuturesTickerParseContext = useFuturesTickerParseContext;
